import { gql } from "@apollo/client";

export const ORDERS_COMPARISON_QUERY = gql`
  query GetOrdersComparisonData($period: Int = 1) {
    getOrdersComparisonData(period: $period) {
      currentPeriod {
        date
        count
        amount
      }
      previousPeriod {
        date
        count
        amount
      }
      periodLabel
      totalCurrentPeriod
      totalPreviousPeriod
      percentageChange
    }
  }
`;
